export default "__VITE_PUBLIC_ASSET__cb6939b6__"